import React from "react";
import withStyles from '@mui/styles/withStyles';
import iconBlueClose from "../../assets/images/icon_blue_close.svg";
import useMakeScrollable from "../../custom_hooks/make-scrollable";

const topOffset = "15%";
const button = {
  border: "none",
  textTransform: "uppercase",
  fontFamily: "Montserrat",
  fontSize: "12px",
  fontWeight: 600,
  borderRadius: "30px",
  padding: "10px",
  width: "50%",
  color: "white",
  backgroundColor: "#8C8C96",
};
const block = {
  padding: "0px 60px 0px 60px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
};
const styles = (theme) => ({
  deleteConfirmation: {
    position: "fixed",
    width: "100vw",
    top: topOffset,
    background: "linear-gradient(#4396e6, #7CD1EA)",
    backgroundColor: "white",
    borderRadius: "15px 15px 0px 0px",
    zIndex: 100,
    boxShadow: "2px 2px 8px grey",
  },
  closeIcon: {
    position: "absolute",
    top: 18,
    right: 13,
  },
  wrapper: {
    padding: "28px 0px 0px 0px",
  },
  buttonDanger: {
    ...button,
    backgroundColor: "#ffab9d",
  },
  buttonAbort: {
    ...button,
    backgroundColor: "white",
  },
  block: block,
  blockWithDelimiter: {
    ...block,
    borderBottom: "1px solid #70707052",
  },
  blueText: {
    color: "#238CB9",
    textAlign: "center",
    textTransform: "uppercase",
    fontFamily: "Montserrat",
    fontWeight: "bold",
    fontSize: "16px",
    padding: "21px 0px",
  },
  buttonText: {
    color: "#238CB9",
    textAlign: "center",
    textTransform: "uppercase",
    fontFamily: "Montserrat",
    fontWeight: "bold",
  },
  whiteText: {
    color: "white",
    textAlign: "center",
    fontFamily: "Montserrat",
    fontWeight: "light",
    fontSize: "25px",
    width: "100%"
  },
});

const DeleteModal = ({ classes, setShowDelete, deleteUser  }) => {
  useMakeScrollable("scrollable-modal");
  const deleteHandler = () => {
      deleteUser()
      setShowDelete(false)
  }
  return (
    <div id="scrollable-modal" className={classes.root} style={{zIndex: 100}}>
      <div className={classes.deleteConfirmation}>
        <div style={{ position: "relative", top: "15px", right: "15px" }}>
          <img
            style={{filter: "invert(91%) sepia(100%) saturate(0%) hue-rotate(264deg) brightness(107%) contrast(101%)"}}
            className={classes.closeIcon}
            src={iconBlueClose}
            alt="Close delete modal"
            onClick={() => {setShowDelete(false)}}
          />
        </div>
        <div>
            <h2 style={{paddingTop: 40}} className={classes.whiteText}>Möchten sie wirklich ihr Profil löschen?</h2>
            <div>
                <p style={{fontSize: 16}} className={classes.whiteText}>Wenn sie ihr Profil löschen kann es nicht wieder hergestellt werden und all ihre Daten und bisherigen Erfolge werden unwiederuflich gelöscht.</p>
            </div>
            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                <div
                  className={classes.buttonDanger}
                  style={{ justifyContent: 'center', alignItems: 'center', marginBottom: 20, marginTop: 40}}
                  onClick={() => deleteHandler()}
                >
                  <p style={{textAlign: 'center'}}>Profil löschen</p>
                </div>
            </div>
            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                <div
                  className={classes.buttonAbort}
                  style={{ justifyContent: 'center', alignItems: 'center', marginBottom: 800}}
                  onClick={() => setShowDelete(false)}
                >
                  <p className={classes.buttonText} style={{alignItems: 'center'}}>Abbrechen</p>
                </div>
            </div>
        </div>
      </div>
    </div>
  );
};
export default withStyles(styles)(DeleteModal);
